import React, { Component } from "react";
import { reduxForm } from "redux-form";
import { BlueBtn } from "components/Controls";
import { connect } from "react-redux";
import { selectOffer } from "../../actions";
import { mergeRight } from "ramda";
import { BuyoutInfo, OfferView } from "components/DataDisplay";
import {trendingsVisitID} from "../../selectors";
import { createStructuredSelector } from "reselect";
import PropTypes from "prop-types";
import { AnalyticAPI } from "api/analytic";
import { tokenSelector } from "containers/EmbeddableWidget/selectors";
import OfferHeader from "../OfferHeader";
import { buildOfferData } from "containers/MultistepForm/helpers";
import { addThousandsSeparator, paymentFrequency } from "utils/helpers";

import "./styles.scss";

class Katapult2Offer extends Component {
  state = {
    loading: false,
    selectedOption: null,
  };

  componentDidMount = () => {
    const { offer } = this.props;
    this.setSelected(offer.options[0]);
  };

  setSelected = (option) => {
    const { offer } = this.props;

    option = mergeRight(option, {
      app_id: offer.app_id,
      provider: offer.provider,
      payment_schedule: offer.payment_schedule,
      approved_amount: offer.approved_amount,
      specific_provider_name: offer.provider,
      cart_total: offer.cart_total,
      promo: offer.promo,
    });
    this.props.getSelectedOffer(option);
    this.setState({ selectedOption: option });
  };

  submitForm = (e) => {
    const { offer, logContinueEvent, selectOffer } = this.props;
    const { token, visitID } = this.props;
    AnalyticAPI.send_provider_analytic_event(
      token,
      "select_provider",
      "katapult",
      visitID
    );

    logContinueEvent()
    e.preventDefault();
    this.setState({ loading: true });
    selectOffer({ selectedOffer: offer });
  };

  render() {
    const { selectedOption, loading } = this.state;
    const { available, isExpanded, offer, toggleExpanded } = this.props;
    const { header, body } = offer.promotion || {};

    if (!selectedOption) {
      return "";
    }

    return (
      <div className="expanded-block-component__expanded-content">
        <OfferHeader
          available={available}
          isExpanded={isExpanded}
          dueToday={addThousandsSeparator(selectedOption.initial_payment)}
          specificProviderName={offer.specific_provider_name}
          paymentPeriod={`${selectedOption.payment_period} Months`}
          paymentFrequency={paymentFrequency(selectedOption)}
          approvedAmount={offer.approved_amount}
          typeOfPlan={selectedOption.type}
          toggleExpanded={toggleExpanded}
          promo={offer.promo}
        />
        {isExpanded && (
          <form
            onSubmit={(e) => this.submitForm(e)}
            className="paytomorrow-offer application-offer"
          >
            <div className="step3__recommended-offer-plan offer-plan__top flex flex--wrap">
              <OfferView offerData={buildOfferData(selectedOption)}  />
            </div>
            {(offer.promo && header && body) && <BuyoutInfo title={header} text={body} />}
              <BuyoutInfo title={"Early Purchase Option"} text={'You can buy out your lease-to-own agreement within the first 90-days. This amount includes the cash price, plus the lease-to-own cost for the first 90-days. Taking advantage of the 90-day purchase option will save you the most money!'} />
              <BuyoutInfo title={"No Late Fees!"} text={''} />
            <BlueBtn
              customClass="step3__recommended-content-btn"
              disabled={!available}
              loading={loading}
              type="submit"
            >
              Continue with Katapult
            </BlueBtn>
          </form>)}
      </div>
    );
  }
}

Katapult2Offer.propTypes = {
  offer: PropTypes.object.isRequired,
  available: PropTypes.bool,
};

Katapult2Offer.defaultProps = {
  available: true,
};

const mapStateToProps = createStructuredSelector({
  token: tokenSelector(),
  visitID: trendingsVisitID(),
});

const mapDispatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
  };
};

Katapult2Offer = connect(mapStateToProps, mapDispatchToProps)(Katapult2Offer);

Katapult2Offer = reduxForm({
  form: "form",
})(Katapult2Offer);

export default Katapult2Offer;
